const changeLogArchive = [
  {
    version: "05.04.05",
    issues: [
      {id: "ITRACEV5-80", description: "Added support for parsing out posting errors so they can be displayed in the grid as a separate section (to make them easier to identify)."},
      {id: "ITRACEV5-62", description: "Modified App Title."},
    ]
  },
  {
    version: "05.04.04",
    issues: [
      {id: "ITRACEV5-CORE", description: "Fixed issue where conversion to Despatch Advice PO Entity LineItemNumber was not displaying a null node (it was being removed)."},
      {id: "ITRACEV5-75", description: "Fixed defect where History Grid detail was showing repost as true when record had not been reposted."},
      {id: "ITRACEV5-65", description: "Send user a message that repost has started so user knows the repost was initiated."}
    ]
  },
  {
    version: "05.04.03",
    issues: [
      {id: "ITRACEV5-61", description: "Added ability to download a zip file of all posted xml documents."}
    ]
  },
  {
    version: "05.04.02",
    issues: [
      {id: "ITRACEV5-60", description: "Fixed Subscriptions maintenance issue where editing a subscription did not load existing subscriber rules."}
    ]
  },
  {
    version: "05.04.01",
    issues: [
      {id: "ITRACEV5-50", description: "Implemented Repost and added Repost to history grid."}
    ]
  },
  {
    version: "05.03.02",
    issues: [
      {id: "ITRACEV5-51", description: "Added Telemetry Events detail."}
    ]
  },
  {
    version: "05.03.01",
    issues: [
      {id: "ITRACEV5-54", description: "Added Telemetry Log Events Page"}
    ]
  },
  {
    version: "05.02.04",
    issues: [
      {id: "ITRACEV5-51", description: "Fixed expanding Tree node"},
      {id: "ITRACEV5-49", description: "Changed Posted History grid column order."},
      {id: "ITRACEV5-55", description: "Added Refresh button"},
      {id: "ITRACEV5-58", description: "Pointed to Supplier Config for orgConfiguration page."},
      {id: "ITRACEV5-56", description: "Removed SMS from Subscriber Management" }
    ]
  }
  ];
  
  export default changeLogArchive;
  